import React, {Component} from 'react'
import {Checkbox} from 'components/styled/Checkbox'
import FormContext from 'components/FormContext'
import styles from './styles'
import {ReadOnly, Markdown, MultiSelect, MemberTitle, FileUploadField} from 'components'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import Collapse from '@material-ui/core/Collapse'
import pluralize from 'pluralize'

export class Certification extends Component {
  static defaultProps = {
    name: 'account.steps.certification',
  }

  get certifiable() {
    return this.props.context.metCertificationItems && this.props.context.metCertificationItems.length > 0
  }

  getMetCertificationItem = id => {
    const items = this.props.context.metCertificationItems
    const metItem = items.find(item => this.certificationsMatch(item, {certificationItemId: id}))
    return metItem ? {...metItem, index: items.indexOf(metItem)} : metItem
  }

  createMetCertificationItem = (item) => {
    return {certificationItemId: item.id, supportingAttachment: null}
  }

  certificationsMatch = (c1, c2) => `${c1.certificationItemId}` === `${c2.certificationItemId}`

  handleMetaRef = meta => ref => {
    Object.keys(ref).forEach(k => meta[k] = ref[k])
    this.props.metaRef(meta)
  }

  renderCertificationItem = meta => item => {
    const {context, onChange, errorContext} = this.props
    const metItem = this.getMetCertificationItem(item.id)
    return (
      <div>
        <Markdown mdtext={item.question} />
        {item.requireAttachment &&
          <Collapse in={!!metItem}>
            <FormContext
              member={metItem && `metCertificationItems[${metItem.index}]`}
              errorMember={metItem && `metCertificationItems['${metItem.certificationItemId}']`}
              context={context}
              onChange={onChange}
              errorContext={errorContext}
              metaRef={this.handleMetaRef(meta)}
            >
              <Typography variant="body1">Supported file type: .PDF, .JPG, .GIF or .PNG</Typography>
              <FileUploadField member='supportingAttachment' required={!!metItem}/>
            </FormContext>
          </Collapse>
        }
      </div>
    )
  }

  render = () => {
    const meta = {}
    const {context, onChange, errorContext} = this.props
    const {country, limitedUpdate} = context
    const {certificationHeading, certificationPreamble, certificationItems} = country
    const investorTerm = pluralize.singular(certificationHeading).toLowerCase()
    return (
      <ReadOnly on={this.props.review || limitedUpdate}>
        <FormContext
          context={context}
          onChange={onChange}
          errorContext={errorContext}
          metaRef={this.handleMetaRef(meta)}
        >
          <div className={styles.section}>
            <Typography><Markdown mdtext={certificationPreamble} /></Typography>
            <MultiSelect
              member='metCertificationItems'
              className={styles.checkList}
              classes={{checkbox: styles.listCheckbox}}
              options={certificationItems}
              labelProvider={this.renderCertificationItem(meta)}
              valueProvider={this.createMetCertificationItem}
              equalityProvider={this.certificationsMatch}
            />
          </div>
          <Tooltip
            title={this.certifiable ? '' : 'You must select your criteria first.'}
            placement="bottom-start"
          >
            <MemberTitle variant='body1' member='certifiedAt' style={{display: 'inline-block'}}>
              <Checkbox
                style={{marginLeft: -12}}
                disabled={!this.certifiable}
                member='certifiedAt'
                checkedAsTime
                required
                meta={{requiredError: `You must be certified as a ${investorTerm} to register your account.`,
                       errorLabel: 'Certification'}}
              /> I certify that I am a {investorTerm}
            </MemberTitle>
          </Tooltip>
        </FormContext>
      </ReadOnly>
    )
  }
}